import { endpointDeclaration } from '@moojo/endpoints'
import { ShopIcp } from '@moojo/shop-icp'
import { z } from 'zod'

export const CalibrateRequest = z.object({
  agentId: z.string(),
  calibrationId: z.string().uuid().optional(),
  shopUrl: z.string(),
  /**
   * The Ideal Customer Profile (ICP) for the shop.
   * If not provided, an ICP will be extracted from the shop's website (`shopUrl`).
   */
  shopIcp: ShopIcp.optional(),
  // TODO(imaman): retire
  /**
   * @deprecated. no longer in use.
   */
  llmSelection: z.union([z.literal('fixed'), z.literal('dynamic')]).optional(),
  /** Whether to enable experiments. Defaults to false */
  experimental: z.boolean().optional(),
  /** Whether to merge the ICP with a default one to prevent an empty ICP. Defaults to true */
  defaultize: z.boolean().optional(),
})

export type CalibrateRequest = z.infer<typeof CalibrateRequest>

export const CalibrateResponse = z.object({
  calibrationId: z.string(),
})

export type CalibrateResponse = z.infer<typeof CalibrateResponse>

export const calibrateDeclaration = endpointDeclaration(CalibrateRequest, CalibrateResponse)
